import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Link, Navigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import "./custom.css";
import https from "../../base/utils/http";
import { useNavigate } from "react-router-dom";
import { httpService } from "../../base/services/httpService.service";

const initialValues = {
   email: ""
};

function ForgotPassword(props) {
   const navigate = useNavigate();
   const { intl } = props;
   const [isRequested] = useState(false);
   const ForgotPasswordSchema = Yup.object().shape({
      email: Yup.string()
         .email("Wrong email format")
         .min(3, "Minimum 3 symbols")
         .max(50, "Maximum 50 symbols")
         .required(
            intl.formatMessage({
               id: "AUTH.VALIDATION.REQUIRED_FIELD"
            })
         )
   });
   const handleSubmit = (values) => {
      httpService.post(
         "/account/generaterecoverpasswordcode",
         {
            email: values.email
         },
         () => {
            navigate("/auth/password-confirm");
         }
      );
   };

   return (
      <>
         {isRequested && <Navigate to="/auth" />}
         {!isRequested && (
            <div className="login-form login-forgot" style={{ display: "block" }}>
               <div className="text-center mb-10 mb-lg-20">
                  <h3 className="font-size-h1">Recover Password ?</h3>
                  <div className="text-muted font-weight-bold">
                     Enter your email to reset your password
                  </div>
               </div>
               <Formik
                  initialValues={initialValues}
                  validationSchema={ForgotPasswordSchema}
                  onSubmit={(values) => {
                     handleSubmit(values);
                  }}
               >
                  {({ handleSubmit, handleChange, values, errors }) => (
                     <form
                        onSubmit={handleSubmit}
                        className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                     >
                        <div className="form-group fv-plugins-icon-container">
                           <input
                              className={`form-control h-auto py-5 px-6`}
                              type="email"
                              placeholder="Email"
                              name="email"
                              onChange={handleChange}
                              values={values.email}
                           />
                           {errors.email && <div className="error-message">{errors.email}</div>}
                        </div>
                        <div className="form-group d-flex flex-wrap flex-center">
                           <button
                              type="submit"
                              className="btn btn-submit font-weight-bold px-9 py-4 my-3 mx-4"
                           >
                              Submit
                           </button>
                           <Link to="/auth">
                              <button
                                 type="button"
                                 id="kt_login_forgot_cancel"
                                 className="btn sign-btn font-weight-bold px-9 py-4 my-3 mx-4"
                              >
                                 Cancel
                              </button>
                           </Link>
                        </div>
                     </form>
                  )}
               </Formik>
            </div>
         )}
      </>
   );
}

export default injectIntl(ForgotPassword);
